<template>
  <div style="height:100vh;overflow:hidden;" class="background animate__animated animate__fadeIn">
    <header
      class="py-2 animate__animated animate__fadeIn animate__faster w-full"
      style="position:fixed;z-index:10;"
    >
      <div class="flex items-center">
        <div class="flex-1 text-right text-white">
          <div class="py-2 px-4 bg-transparent text-white inline-block">
            <span class="icon">
              <i class="fas fa-medal text-orange-300"></i>
              &nbsp;TU RECORD: {{ record }}
            </span>
          </div>
        </div>
      </div>
    </header>

    <div style="height:50vh;position:relative;" class="text-center">
      <div style="clear:both;height:60%"></div>
      <i
        class="fad fa-calculator text-yellow-100"
        style="position:absolute;top:calc(55% - 60px);left:calc(50% - 60px);font-size:120px;z-index:1;opacity:0.25;transform:rotate(-15deg);"
      ></i>
      <div
        class="animate__animated animate__zoomIn animate__fast title"
        style="position:relative;z-index:2;"
      >
        <div
          style="font-size:70px;transform:rotate(10deg);text-shadow: 6px 6px 16px rgba(0,0,0,0.3);"
        >
          <b class="text-white">CALCUCIL</b>
        </div>
      </div>
    </div>
    <div style="height:30vh;" class="text-center">
      <div style="clear:both;height:50%"></div>
      <div class="animate__animated animate__pulse animate__infinite">
        <div style="transform:rotate(-5deg);">
          <button
            @click="onPlayClicked()"
            class="button is-yellow shadow-md text-blue-500"
            style="transform:scale(2.5);"
          >{{ $t('home.jugar') }}</button>
        </div>
      </div>
    </div>

    <div style="height:20vh;" class="text-center" v-if="false">
      <div style="clear:both;height:50%"></div>
      <button
        @click="onInstructionsClicked()"
        class="button bg-transparent text-white"
      >{{ $t('home.instrucciones') }}</button>
    </div>

    <header
      class="py-4 px-4 animate__animated animate__fadeIn animate__faster w-full text-right text-xs text-blue-400"
      style="position:fixed;z-index:9;bottom:0;right:0;"
    >
      v3.7
    </header>

    <header
      class="py-4 px-4 animate__animated animate__fadeIn animate__faster w-full"
      style="position:fixed;z-index:10;bottom:0;"
    >
      <button class="button bg-transparent text-white" @click="onMuteSoundClicked();">
        <i v-if="!muteSound" class="fas fa-volume"></i>
        <i v-if="muteSound" class="fas fa-volume-slash"></i>
      </button>
      <button class="button bg-transparent text-white" @click="onMuteMusicClicked();">
        <i v-if="!muteMusic" class="fas fa-music"></i>
        <i v-if="muteMusic" class="fas fa-music-slash"></i>
      </button>
    </header>
  </div>
</template>

<script>
export default {
  name: "app-welcome",
  data() {
    return {
      record: 0,
      muteSound: false,
      muteMusic: false,
    };
  },
  mounted: function () {},
  created: function () {
    const data = JSON.parse(localStorage.getItem("calcucil-data") || "{}");
    const settings = JSON.parse(
      localStorage.getItem("calcucil-settings") || "{}"
    );

    this.muteSound = settings.muteSound || false;
    this.muteMusic = settings.muteMusic || false;

    this.record = data.record || 0;
  },
  methods: {
    onPlayClicked() {
      this.$router.push("playing");
    },
    onInstructionsClicked() {
      this.$router.push("instructions");
    },
    onMuteSoundClicked() {
      const settings = JSON.parse(
        localStorage.getItem("calcucil-settings") || "{}"
      );
      settings.muteSound = !settings.muteSound;
      this.muteSound = settings.muteSound || false;
      localStorage.setItem("calcucil-settings", JSON.stringify(settings));
    },
    onMuteMusicClicked() {
      const settings = JSON.parse(
        localStorage.getItem("calcucil-settings") || "{}"
      );
      settings.muteMusic = !settings.muteMusic;
      this.muteMusic = settings.muteMusic || false;
      localStorage.setItem("calcucil-settings", JSON.stringify(settings));

      if (this.muteMusic) {
        window.introMusic.pause();
        window.introMusic.currentTime = 0;
      } else {
        window.introMusic.play();
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/00-Welcome.vue